<template>
	<article class="ingredient">
		<managing-section>
			<managing-box title="성분명">
				<input
					v-model="keyword"
					type="text"
					placeholder="성분명 (한/영) 입력..."
					@keyup.enter="searching"
				/>
			</managing-box>
		</managing-section>
		<div class="btn-wrap-main">
			<button class="btn-main blue" @click="searching">검색</button>
		</div>
		<managing-section v-if="ingredientList" :is-table="true">
			<table class="table-main ingredient__table">
				<thead>
					<tr>
						<th
							v-for="th in thList"
							:key="th.id"
							:class="`ingredient__table__${th.id}`"
						>
							{{ th.title }}
						</th>
					</tr>
				</thead>
				<tbody v-if="!ingredientList.length">
					<tr>
						<td :colspan="thList.length">검색결과가 없습니다.</td>
					</tr>
				</tbody>
				<tbody v-else>
					<tr
						v-for="item in ingredientList"
						:key="item.factorIdx"
						class="ingredient__table__tr"
						@click="selectIngredient(item)"
					>
						<td>{{ item.factorIdx }}</td>
						<td>{{ item.ingredientCode }}</td>
						<td>
							<p>{{ item.factorKorean }}</p>
							<p>{{ item.factorEnglish }}</p>
						</td>
						<td>{{ item.factorPurpose }}</td>
						<td>
							{{ item.factorEwgMin }}
							<template v-if="item.factorEwgMax">
								- {{ item.factorEwgMax }}</template
							>
						</td>
						<td>{{ item.useCnt }}</td>
						<td>{{ parsingDate(item.createDate) }}</td>
					</tr>
				</tbody>
			</table>
		</managing-section>
		<managing-section size="l">
			<managing-box title="한글 성분명">
				<input
					v-model="factorKorean"
					type="text"
					placeholder="한글 성분명을 입력하세요"
				/>
			</managing-box>
			<managing-box title="영문 성분명">
				<input
					v-model="factorEnglish"
					type="text"
					placeholder="영문 성분명을 입력하세요"
				/>
			</managing-box>
			<managing-box title="대한화장품협회 코드">
				<input
					v-model="ingredientCode"
					ref="ingredientCode"
					type="text"
					placeholder="대한화장품협회 코드를 입력하세요"
					:disabled="!!noIngredientCode.length"
				/>
				<CheckboxList
					v-model="noIngredientCode"
					:checkboxList="[{ id: true, value: '협회코드없음' }]"
				/>
			</managing-box>
			<managing-box title="EWG 등급">
				<period-box
					mode="number"
					from-placeholder="EWG 최소 등급을 입력하세요.(깂이 하나라면 여기!)"
					to-placeholder="EWG 쵀대 등급을 입력하세요."
					:input-width="380"
					:from-value="factorEwgMin"
					:to-value="factorEwgMax"
					@change="change"
				/>
			</managing-box>
			<managing-box title="배합목적">
				<input
					v-model="factorPurpose"
					type="text"
					placeholder="배합목적을 입력하세요. 예) 산화방지제 착향제 환원제 .. 등"
				/>
			</managing-box>
			<managing-box title="기원 및 정의">
				<textarea
					v-model="factorOrigin"
					placeholder="기원 및 정의를 입력하세요. 예) 이 원료는 ..."
				></textarea>
			</managing-box>
			<managing-box title="별명">
				<input
					v-model="factorNickname"
					type="text"
					placeholder="별명을 입력하세요."
				/>
			</managing-box>
			<managing-box title="상품명">
				<input
					v-model="factorPdtname"
					type="text"
					placeholder="상품명을 입력하세요."
				/>
			</managing-box>
			<managing-box title="비고">
				<input
					v-model="factorEtc"
					type="text"
					placeholder="비고사항을 입력하세요."
				/>
			</managing-box>
		</managing-section>
		<div class="btn-wrap-main">
			<button class="btn-main blue" @click="saving">저장하기</button>
			<button class="btn-main orange" @click="init">다시작성</button>
			<button class="btn-main red" @click="deleting">삭제</button>
		</div>
	</article>
</template>
<script>
	import moment from 'moment';
	import ManagingSection from '@/components/layout/ManagingSection';
	import ManagingBox from '@/components/layout/ManagingBox';
	import CheckboxList from '@/components/CheckboxList';
	import PeriodBox from '@/components/PeriodBox';

	export default {
		name: 'IngredientManagement',
		components: {
			ManagingSection,
			ManagingBox,
			CheckboxList,
			PeriodBox,
		},
		data() {
			return {
				lastReq: null,
				keyword: '',
				ingredientList: null,
				thList: [
					{ id: 'id', title: 'ID' },
					{ id: 'ingredientCode', title: '협회코드' },
					{ id: 'name', title: '성분명' },
					{ id: 'purpose', title: '용도' },
					{ id: 'ewg', title: 'EWG' },
					{ id: 'cnt', title: '매칭수' },
					{ id: 'date', title: '등록일' },
				],
				factorIdx: '',
				factorKorean: '',
				factorEnglish: '',
				noIngredientCode: [],
				ingredientCode: '',
				factorEwgMin: '',
				factorEwgMax: '',
				factorPurpose: '',
				factorOrigin: '',
				factorNickname: '',
				factorPdtname: '',
				factorEtc: '',
			};
		},
		mounted() {
			const factorIdx = this.$route.query['factor-idx'];
			if (factorIdx) {
				this.getIngredientItem(factorIdx);
			}
		},
		methods: {
			async reReq() {
				const lastReq = this.lastReq;
				if (lastReq) {
					await this[lastReq.key](lastReq.params);
				}
			},
			async getIngredientItem(factorIdx) {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/products/factors?factorIdx=${factorIdx}`
					);
					this.ingredientList = data.factors;
					this.lastReq = {
						key: 'getIngredientItem',
						params: factorIdx,
					};
				} catch (err) {
					console.error(err);
					alert(
						'성분목록을 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			selectIngredient(data) {
				this.factorIdx = data.factorIdx || '';
				this.factorKorean = data.factorKorean || '';
				this.factorEnglish = data.factorEnglish || '';
				this.noIngredientCode = [];
				this.ingredientCode = data.ingredientCode || '';
				this.factorEwgMin = String(data.factorEwgMin) || '';
				this.factorEwgMax = String(data.factorEwgMax) || '';
				this.factorPurpose = data.factorPurpose || '';
				this.factorOrigin = data.factorOrigin || '';
				this.factorNickname = data.factorNickname || '';
				this.factorPdtname = data.factorPdtname || '';
				this.factorEtc = data.factorEtc || '';
			},
			parsingDate(date) {
				return date
					? moment(date, 'YYYYMMDDHHmmss').format(
							'YYYY-MM-DD HH:mm:ss'
						)
					: '-';
			},
			async getIngredientList() {
				try {
					const params = { keyword: this.keyword };
					const {
						data: { data },
					} = await this.$axiosAdmin2.get(`/api/products/factor`, {
						params,
					});
					this.ingredientList = data;
					this.lastReq = {
						key: 'getIngredientList',
						params,
					};
				} catch (err) {
					console.error(err);
					alert(
						'성분목록을 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			searching() {
				if (this.keyword.length < 2) {
					alert('2자 이상 검색해 주세요');
				} else {
					this.getIngredientList();
				}
			},
			change({ from, to }) {
				this.factorEwgMin = from || '';
				this.factorEwgMax = to || '';
			},
			init() {
				this.factorIdx = '';
				this.factorKorean = '';
				this.factorEnglish = '';
				this.ingredientCode = '';
				this.factorEwgMin = '';
				this.factorEwgMax = '';
				this.factorPurpose = '';
				this.factorOrigin = '';
				this.factorNickname = '';
				this.factorPdtname = '';
				this.factorEtc = '';
			},
			async deleting() {
				try {
					if (!this.factorIdx) {
						alert('선택된 성분이 없습니다');
						return;
					}
					if (!confirm('정말 지우시겠습니까?')) {
						return;
					}
					await this.$axiosAdmin2.delete(
						`/api/products/factors/${this.factorIdx}`
					);
					this.init();
					await this.reReq();
					alert('삭제 되었습니다.');
				} catch (err) {
					console.error(err);
					alert(
						'성분을 삭제하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			async saving() {
				try {
					if (!this.factorKorean && !this.factorEnglish) {
						alert(
							'한국어 혹은 영어 성분명중 최소한 한가지는 입력해야 합니다.'
						);
						return;
					}
					if (!this.noIngredientCode.length && !this.ingredientCode) {
						alert('협회코드를 입력하세요.');
						this.$refs.ingredientCode.focus();
						return;
					}
					if (!confirm('정말 저장하시겠습니까?')) {
						return;
					}
					const params = [
						'factorKorean',
						'factorEnglish',
						'factorEwgMin',
						'factorEwgMax',
						'factorPurpose',
						'factorOrigin',
						'factorNickname',
						'factorPdtname',
						'factorEtc',
						'factorIdx',
					].reduce((acc, key) => {
						if (this[key]) {
							acc[key] = this[key];
						}
						return acc;
					}, {});
					if (!this.noIngredientCode.length) {
						params.ingredientCode = this.ingredientCode;
					}
					const { data } = await this.$axiosAdmin2.post(
						'/api/products/factors',
						null,
						{ params }
					);
					if (data) {
						this.init();
						await this.reReq();
						alert('저장 완료 되었습니다.');
					}
				} catch (err) {
					if (err.response && err.response.status === 409) {
						const msg = this.thList.find(
							item => item.id === 'ingredientCode'
						).title;
						alert(
							err.response.data.message.replace(
								'ingredientCode',
								msg
							)
						);
						this.$refs.ingredientCode.focus();
					} else {
						console.error(err);
						alert(
							'성분을 업데이트하는데 실패했습니다. 개발팀에 문의하세요.'
						);
					}
				}
			},
		},
	};
</script>
<style lang="scss">
	.ingredient__table {
		table-layout: fixed;

		.ingredient__table__tr {
			cursor: pointer;
		}

		.ingredient__table__id {
			width: 80px;
		}

		.ingredient__table__ingredientCode {
			padding: 0;
			width: 140px;
		}

		.ingredient__table__ewg {
			width: 80px;
		}

		.ingredient__table__cnt {
			width: 80px;
		}

		.ingredient__table__date {
			width: 130px;
		}
	}
</style>
